<template>
  <div>
      <a v-for="(link, key) in options.links" :key="key" :href="link.direction">{{link.title}}</a>
  </div>
</template>

<script>
export default {
name: 'tableRowLinks',
props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style>

</style>